import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { GetDate, Number, OpenBase64Pdf, ReverseFormatDate, setFocus, setTitle, formatDate } from "../Common/Common";
import Loader from '../Layout/Loader';
import { API_SERVER } from '../../EnvConfig/env_config';
import { AlertBox, AutoCompleteBox, DateBox } from '../Common/Input';
import { useRef } from 'react';
import { getCommonData } from '../Common/CommanServices';
import { post } from '../Common/service';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

const GenerateInvoice_New = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');

    const [SalesPerson, setSalesPerson] = useState([]);
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [CustomerData, setCustomerData] = useState([]);
    const [ItemNoData, setItemNoData] = useState([]);
    const [TotalEmptyInvoiceAmount, setTotalEmptyInvoiceAmount] = useState(0.00);
    const [MenuText, setMenuText] = useState("Generate Invoice");
    const [PaymentType, setPaymentType] = useState("");

    const [ItemGroup, setItemGroup] = useState('');
    const [MainItemName, setMainItemName] = useState('');
    const [ItemRowNo, setItemRowNo] = useState(0);

    const [modal, setModal] = useState({
        Index: 0,
        Action: "",
        Item: "",
        Quantity: 0
    });

    const [emptyItemDropdown, setEmptyItemDropdown] = useState({
        ItemDetails: []
    });
    const [ItemDetailsDropDown, setItemDetailsDropDown] = useState([]);

    const [AddExtraItem, SetAddExtraItem] = useState({
        Item: "",
        ItemPrice: 0,
        InHandQuantity: 0,
        RequiredQuantity: 0,
        ReturnQuantity: 0,
        NetAmount: 0,
        IsMainItem: true,
        MainItem: "",
        IsItemEnable: false,
        IsOrderItem: false,
        ItemGroup: "",
        InLueItem: []
    });

    const [InvoiceData, setInvoiceData] = useState({
        TotalIssuedQty: 0,
        TotalNetAmount: 0.00,
        GETFUNDPer: 0.00,
        GetFundAmount: 0.00,
        NHILPer: 0.00,
        NhilAmount: 0.00,
        COVIDPer: 0.00,
        CovidAmount: 0.00,
        VATPer: 0.00,
        VatAmount: 0.00,
        GrandTotalAmount: 0.00
    });

    const [isLoading, setIsLoading] = useState(false);

    const [Print, setPrint] = useState({
        InvoiceNo: '',
        IsInvoicePrint: false,

    });

    const [SaveData, setSaveData] = useState({
        InvoiceDate: GetDate(0),
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Customer: "",
        CashAmount: "0.00",
        MobileMoney: "0.00",
        ChequeAmount: "0.00",
        ChequeNo: "",
        ChequeDate: "",
        ItemDetails: [],
        EmptiesDetails: [],
    });


    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }));
    }

    const handleInvoiceData = () => {
        let LoginUserCode = cookies.get('loginUserCode');
        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            let data = {
                Token, LoginUserCode: LoginUserCode,
            }
            post(`${API_SERVER}/api/Operation/GetInvoiceChargePer`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    setInvoiceData({
                        ...InvoiceData,
                        GETFUNDPer: +res.getFundPer,
                        NHILPer: +res.nhilPer,
                        COVIDPer: +res.covidLevyPer,
                        VATPer: +res.vatPer
                    });
                }
                else if (res.message === "EXPIRED") {
                }
                else if (res.message !== "") {
                    AlertBox("error", res.message, "");
                }
                setIsLoading(false);
            })
        };
    }

    const handleGetOrderData = (Customer) => {
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            Customer: Customer,
            ItemDetails: []
        }));
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token, LoginUserCode: loginCodeString, Customer: Customer, SalesPerson: SaveData.SalesPerson
        }
        post(`${API_SERVER}/api/Operation/GetOrderDetails`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                let itemDetails = [];
                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.Item = item.Item;
                    Item.ItemPrice = item.ItemPrice;
                    Item.InHandQuantity = item.InHandQuantity;
                    Item.OrderQuantity = item.OrderQuantity;
                    Item.RequiredQuantity = item.OrderQuantity;
                    Item.ReturnQuantity = item.ReturnQuantity;
                    Item.NetAmount = item.NetAmount;
                    Item.MainItem = item.MainItemCode;
                    Item.ItemGroup = item.ItemGroupCode;
                    Item.InLueItem = [];
                    if (item.IsEmpty === "1") {
                        Item.IsMainItem = false;
                        Item.IsItemEnable = false;
                        Item.IsOrderItem = false
                    }
                    else {
                        Item.IsMainItem = true;
                        Item.IsItemEnable = true;
                        Item.IsOrderItem = false;
                    }
                    itemDetails.push(Item);
                });
                setSaveData(prevSaveData => ({
                    ...prevSaveData,
                    Customer: Customer,
                    ItemDetails: itemDetails
                }));
                setPaymentType(res.Data[0].PaymentType);
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            if (res.PaymentType !== undefined) {
                setPaymentType(res.PaymentType);
            }
            setIsLoading(false);

        })
    };

    const handleGetEmptiesData = (Customer) => {
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            Customer: Customer,
            EmptiesDetails: []
        }));
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token,
            LoginUserCode: loginCodeString,
            Customer: Customer,
            SalesPerson: SaveData.SalesPerson
        }
        post(`${API_SERVER}/api/Operation/GetEmptyItem`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                let emptiesDetails = [];
                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.Item = item.Item;
                    Item.ItemPrice = item.ItemPrice;
                    Item.Quantity = item.Quantity;
                    Item.ReturnQuantity = item.ReturnQuantity;
                    Item.InvoiceQuantity = item.InvoiceQuantity;
                    Item.TotalAmount = item.TotalAmount;
                    emptiesDetails.push(Item);
                });
                setSaveData(prevSaveData => ({
                    ...prevSaveData,
                    Customer: Customer,
                    EmptiesDetails: emptiesDetails
                }));
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            setIsLoading(false);

        })
    };

    const handleCalulateAmount = () => {
        let totalNetAmountMainItem = 0;
        let totalNetAmountEmptyItem = 0;
        let orderData = [...SaveData.ItemDetails];
        totalNetAmountMainItem = orderData.filter(item => item.IsMainItem === true).map(item => parseFloat(item.NetAmount)).reduce((prev, curr) => prev + curr, 0);
        totalNetAmountEmptyItem = orderData.filter(item => item.IsMainItem === false).map(item => parseFloat(item.NetAmount)).reduce((prev, curr) => prev + curr, 0);

        let emptyData = [...SaveData.EmptiesDetails];
        let totalEmptyAmount = emptyData.map(item => parseFloat(item.TotalAmount)).reduce((prev, curr) => prev + curr, 0);
        setTotalEmptyInvoiceAmount(totalEmptyAmount);

        const loginCodeString = String(LoginUserCode);
        const data = {
            ...SaveData,
            Token,
            LoginUserCode: loginCodeString,
            Source: 'WEB'
        };
        post(`${API_SERVER}/api/Operation/CalculateInvoiceAmount`, data, (res) => {
            if (res.status === 'SUCCESS') {
                setInvoiceData({
                    ...InvoiceData,
                    TotalNetAmount: totalNetAmountMainItem + totalNetAmountEmptyItem,
                    GetFundAmount: res.getfund,
                    NhilAmount: res.nhil,
                    CovidAmount: res.covidlevy,
                    VatAmount: res.vat,
                    GrandTotalAmount: res.grandtotal
                });
            } else if (res.message === "EXPIRED") {
                navigate('/Login')
            } else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        });
    }

    useEffect(() => {
        if (SaveData.ItemDetails !== undefined) {
            if (SaveData.ItemDetails.length > 0 || SaveData.EmptiesDetails.length > 0) {
                handleCalulateAmount();
            } else {
                setInvoiceData({
                    ...InvoiceData,
                    TotalIssuedQty: 0.00,
                    TotalNetAmount: 0.00,
                    GetFundAmount: 0.00,
                    NhilAmount: 0.00,
                    CovidAmount: 0.00,
                    VatAmount: 0.00,
                    GrandTotalAmount: 0.00
                });
            }
        }
    }, [SaveData.ItemDetails, SaveData.EmptiesDetails]);

    const handleOnChangeCustomerQuantity = async (e, rowIndex) => {
        const newItemDetails = [...SaveData.ItemDetails];
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        const totalQuantity = parseInt(inputValue) + parseInt(newItemDetails[rowIndex].ReturnQuantity);
        //if (totalQuantity > parseInt(newItemDetails[rowIndex].InHandQuantity)) {
        //    AlertBox("error", "You don't have enough Quantity for invoice..", "");
        //}
        //else {
            newItemDetails[rowIndex].RequiredQuantity = +Number(inputValue);
            newItemDetails[rowIndex].NetAmount = (+Number(inputValue) * +newItemDetails[rowIndex].ItemPrice).toFixed(2);
            setSaveData({
                ...SaveData,
                ItemDetails: newItemDetails
            });
        //}
    }

    const handleOnChangeCustomerReturnQuantity = async (e, rowIndex) => {
        const newItemDetails = [...SaveData.ItemDetails];
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        const totalQuantity = parseInt(inputValue) + parseInt(newItemDetails[rowIndex].RequiredQuantity);
        if (totalQuantity > parseInt(newItemDetails[rowIndex].InHandQuantity)) {
            AlertBox("error", "You don't have enough quantity for return..", "");
        }
        else {
            newItemDetails[rowIndex].ReturnQuantity = +Number(inputValue);
            setSaveData({
                ...SaveData,
                ItemDetails: newItemDetails
            });
        }
    }

    const handleGetItemDetails = async (ItemNo) => {
        const Token = await cookies.get('token');
        let LoginUserCode = await cookies.get('loginUserCode');
        SetAddExtraItem(
            {
                ...AddExtraItem,
                ItemPrice: 0,
                InHandQuantity: 0,
                RequiredQuantity: 0,
                ReturnQuantity: 0,
                NetAmount: 0,
                IsMainItem: true,
                MainItem: "",
                IsItemEnable: false,
                IsOrderItem: false,
                ItemGroup: "",
                InLueItem: []
            })
        setIsLoading(true);

        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                Token: Token, LoginUserCode: LoginUserCode, ItemNo: ItemNo, SalesPerson: SaveData.SalesPerson, Customer: SaveData.Customer
            }
            post(`${API_SERVER}/api/Operation/ValidateItemForRequestList`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    SetAddExtraItem(
                        {
                            ...AddExtraItem,
                            Item: res.item,
                            ItemPrice: res.itemPrice,
                            InHandQuantity: +res.quantityInHand,
                            RequiredQuantity: 0,
                            ReturnQuantity: 0,
                            NetAmount: 0,
                            IsMainItem: true,
                            MainItem: res.item,
                            IsItemEnable: true,
                            IsOrderItem: false,
                            ItemGroup: res.itemGroupCode,
                            InLueItem: []
                        })
                    setFocus('txtQuantity')
                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    AlertBox("error", res.message, "");
                }
                setIsLoading(false);
            })
        }
    }

    const handleOnChangeItemQuantity = (e) => {
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        //if (+Number(inputValue) > AddExtraItem.InHandQuantity) {
        //    AlertBox("error", "You don't have enough quantity to generate invoice..", "txtQuantity");
        //    SetAddExtraItem({
        //        ...AddExtraItem,
        //        RequiredQuantity: 0,
        //    });
        //}
       // else {
            SetAddExtraItem({
                ...AddExtraItem,
                RequiredQuantity: Number(inputValue),
                NetAmount: Number(inputValue) * +AddExtraItem.ItemPrice,
            });
        //}
    }

    const handleAddNewItem = () => {
        let Item = AddExtraItem.Item;
        let Quantity = AddExtraItem.RequiredQuantity;
        if (SaveData.Customer === "") {
            AlertBox("error", "Please enter customer.", "txtCustomer");
        }
        else if (AddExtraItem.Item === "") {
            AlertBox("error", "Please enter item.", "txtItemNo");
        }
        else if (SaveData.ItemDetails.filter(item => item.Item === Item).length > 0) {
            AlertBox("error", "Item already exists in list", "txtItemNo");
        }
        else if (AddExtraItem.RequiredQuantity === "" || parseFloat(AddExtraItem.RequiredQuantity) <= 0) {
            AlertBox("error", "Quantity should greater than 0", "txtQuantity");
        }
        else {
            AddEmptyItemDropdown('test');
            setSaveData(prevSaveData => ({
                ...prevSaveData,
                ItemDetails: [...prevSaveData.ItemDetails, AddExtraItem]
            }));

            SetAddExtraItem({
                ...AddExtraItem,
                Item: "",
                ItemPrice: 0,
                InHandQuantity: 0,
                RequiredQuantity: 0,
                ReturnQuantity: 0,
                NetAmount: 0,
                IsMainItem: true,
                MainItem: "",
                IsItemEnable: false,
                IsOrderItem: false,
                ItemGroup: "",
                InLueItem: []
            });
            AddEmptyItem(Quantity, Item);
        }
    };


    const AddEmptyItem = async (Quantity, Item) => {
        //Empty Item
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token,
            LoginUserCode: loginCodeString,
            ItemNo: Item,
            Customer: SaveData.Customer,
            SalesPerson: SaveData.SalesPerson
        }
        post(`${API_SERVER}/api/Operation/GetEmptyItem`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                res.Data.forEach(async (item, index) => {
                    let EmptyItem = {};
                    EmptyItem.Item = item.ItemNo;
                    EmptyItem.ItemPrice = item.ItemPrice;
                    EmptyItem.InHandQuantity = item.InHandQuantity * Quantity;
                    EmptyItem.OrderQuantity = 0;
                    EmptyItem.RequiredQuantity = 0;
                    EmptyItem.ReturnQuantity = item.InHandQuantity * Quantity;
                    EmptyItem.NetAmount = 0;
                    EmptyItem.MainItem = Item;
                    EmptyItem.IsMainItem = false;
                    EmptyItem.IsOrderItem = false;
                    EmptyItem.IsItemEnable = false;
                    EmptyItem.ItemGroup = item.ItemGroupCode;
                    EmptyItem.InLueItem = [];
                    setSaveData(prevSaveData => ({
                        ...prevSaveData,
                        ItemDetails: [...prevSaveData.ItemDetails, EmptyItem]
                    }));
                    await AddEmptyItemDropdown(item.EmptyItemCode)
                });
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            setIsLoading(false);

        })
    }

    const AddEmptyItemDropdown = async (Item = '') => {
        const loginCodeString = String(LoginUserCode);
        let testItem = AddExtraItem.Item;
        let data = {
            Token: Token,
            LoginUserCode: loginCodeString,
            Item: Item,
        }
        post(`${API_SERVER}/api/Operation/GetEmptyItemDropdown`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                const newItems = res.Data.map(item => ({
                    EmptyItemCode: item.EmptyItemCode,
                    ItemNo: item.ItemNo,
                    forDeletKey: testItem
                }));
                //setEmptyItemDropdown(prevSaveData => ({
                //    ...prevSaveData,
                //    ItemDetails: [...prevSaveData.ItemDetails, ...newItems]
                //}));
                setItemDetailsDropDown(prevSaveData => ([
                    ...prevSaveData,
                    newItems
                ]));
            }
            else if (res.Status === "ERROR") {
                let tempArr = [[]];
                if (Item === 'test') {
                    setItemDetailsDropDown(prevSaveData => ([
                        ...prevSaveData,
                        tempArr
                    ]));
                }
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            setIsLoading(false);
        })
    }

    const handleRemoveExtraItemRow = (Item) => {
        const updatedState = ItemDetailsDropDown
            .map(group => group.filter(item => item.forDeletKey !== Item))
            .filter(group => group.length > 0);

        setItemDetailsDropDown(updatedState);

        setSaveData(prevSaveData => ({
            ...prevSaveData,
            ItemDetails: prevSaveData.ItemDetails.filter(item => item.MainItem !== Item)
        }));


        //setSaveData(prevSaveData => ({
        //    ...prevSaveData,
        //    ItemDetails: prevSaveData.ItemDetails.filter((_, i) => i !== indexToRemove)
        //}));
    };

    const handleOnChangeEmptiesReturnQuantity = (e, rowIndex) => {
        const newEmptiesDetails = [...SaveData.EmptiesDetails];
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');

        const totalQuantity = parseInt(inputValue) + parseInt(newEmptiesDetails[rowIndex].InvoiceQuantity);
        //if (totalQuantity > parseInt(newEmptiesDetails[rowIndex].Quantity)) {
        //    AlertBox("error", "You don't have enough Quantity to Return.", "");
        //}
        //else {
            setSaveData(prevSaveData => ({
                ...prevSaveData,
                EmptiesDetails: prevSaveData.EmptiesDetails.map((item, i) => {
                    if (i === rowIndex) {
                        return { ...item, ReturnQuantity: inputValue };
                    }
                    return item;
                })
            }))
        //}
    };

    const handleOnChangeEmptiesInvoiceQuantity = (e, rowIndex) => {
        const newEmptiesDetails = [...SaveData.EmptiesDetails];
        let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
        const totalQuantity = parseInt(inputValue) + parseInt(newEmptiesDetails[rowIndex].ReturnQuantity);
        //if (totalQuantity > parseInt(newEmptiesDetails[rowIndex].Quantity)) {
        //    AlertBox("error", "You don't have enough Quantity for Invoice.", "");
        //    return;
        //}
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            EmptiesDetails: prevSaveData.EmptiesDetails.map((item, i) => {
                if (i === rowIndex) {
                    let totalAmount = (+Number(inputValue) * item.ItemPrice);
                    return { ...item, InvoiceQuantity: inputValue, TotalAmount: totalAmount };
                }
                return item;
            })
        }));
    };

    const handleClearData = () => {
        setSaveData({
            ...SaveData,
            InvoiceDate: GetDate(0),
            SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
            Customer: "",
            CashAmount: "0.00",
            MobileMoney: "0.00",
            ChequeAmount: "0.00",
            ChequeNo: "",
            ChequeDate: "",
            ItemDetails: [],
            EmptiesDetails: [],
        });
        setFocus('txtSalesPerson')
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }

    const getEmptyItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetEmptyItemGroupList",
            Prefix: "",
            ContextKey: ItemGroup,
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }

    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    const handleSaveData = async (Item, BodyIndex) => {
        const grandTotalAmount = String(InvoiceData.GrandTotalAmount)
        var msg = "";
        if (grandTotalAmount === '0') {
            msg = "Are you sure you have received empty items ?";
        }
        else {
            msg = "Do you want Generate Invoice ?";
        }
        Swal.fire({
            title: msg,
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                const loginCodeString = String(LoginUserCode);
                const data = {
                    ...SaveData,
                    Token,
                    LoginUserCode: loginCodeString,
                    Source: 'WEB'
                };

                post(`${API_SERVER}/api/Operation/GenerateInvoice`, data, (res) => {
                    setIsLoading(false);
                    if (res.status === 'SUCCESS') {
                        if (res.message !== "") {
                            AlertBox(res.status, res.message, res.focus);
                        }
                        if (res.isInvoicePrint) {
                            setPrint({
                                InvoiceNo: res.invoiceNo,
                                IsInvoicePrint: res.isInvoicePrint,
                            });
                            OpenBase64Pdf(res.base64PDF, 'CustomerInvoicePrint_' + res.invoiceNo, '_blank');
                        }
                        handleClearData();
                    } else if (res.message === "EXPIRED") {
                        navigate('/Login')
                    } else if (res.message !== "") {
                        AlertBox(res.status, res.message, res.focus);
                    }
                    setIsLoading(false);
                });
            }
        });
    };
    const handleEmptyItemDropdownChange5 = (event, index, item) => {
        const selectedValue = event.target.value + " : " + event.target.value;
        //const newItemDetails = [...SaveData.ItemDetails];
        //newItemDetails[index].Item = selectedValue
        //setSaveData({
        //    ...SaveData,
        //    ItemDetails: newItemDetails
        //})

        setSaveData(prevSaveData => {
            const newData = { ...prevSaveData };
            const inLueItems = newData.ItemDetails[index].InLueItem;
            // Check if the selected value already exists in the array
            const existingItemIndex = inLueItems.findIndex(item => item.Item === selectedValue);

            if (existingItemIndex !== -1) {
                // If the item exists, update it
                inLueItems[existingItemIndex] = {
                    ...inLueItems[existingItemIndex],
                    Quantity: item.OrderQuantity // Update quantity if needed
                };
            } else {
                // If the item doesn't exist, push a new item
                inLueItems.push({
                    Visible: false,
                    Item: selectedValue,
                    Quantity: item.OrderQuantity
                });
            }

            return newData;
        });   
    };
    const handleEmptyItemDropdownChange = (event, index, item) => {
        const selectedValue = event.target.value + " : " + event.target.value;

        setSaveData(prevSaveData => {
            const newData = { ...prevSaveData };
            const inLueItems = newData.ItemDetails[index].InLueItem;
            if (inLueItems.length > 0) {
                inLueItems[0] = {
                    ...inLueItems[0],
                    Item: selectedValue,
                    Quantity: item.ReturnQuantity 
                };
            } else {
                inLueItems.push({
                    Visible: false,
                    Item: selectedValue,
                    Quantity: item.ReturnQuantity
                });
            }
            return newData;
        });
    };


    //Handle  Add
    const HandleAddInLue = () => {
        if (modal.Item.trim() === "") {
            AlertBox("error", "Please enter item.", "txtInLueEmptyItemNo");
        }
        else if (modal.Quantity <= 0) {
            AlertBox("error", "Please enter quantity.", "txtInLueQuantity");
        }
        else {
            if (modal.Action === 'Edit') {
                setSaveData(prevSaveData => {
                    const newData = { ...prevSaveData };
                    newData.ItemDetails[ItemRowNo].InLueItem[modal.Index] = {
                        ...newData.ItemDetails[ItemRowNo].InLueItem[modal.Index],
                        Item: modal.Item,
                        Quantity: modal.Quantity
                    };
                    return newData;
                });
            } else {
                setSaveData(prevSaveData => {
                    const newData = { ...prevSaveData };
                    newData.ItemDetails[ItemRowNo].InLueItem.push({ Visible: false, Item: modal.Item, Quantity: modal.Quantity });
                    return newData;
                });
            }
            HandleResetInLue();
            setFocus("txtInLueEmptyItemNo");
        }
    }

    // Handle Reset
    const HandleResetInLue = () => {
        setModal(
            {
                Index: 0,
                Action: "",
                Item: "",
                Quantity: 0
            }
        );
    }

    //Handle  Edit
    const handleEditInLue = (index) => {
        const inLueItem = SaveData.ItemDetails[ItemRowNo].InLueItem[index];
        setModal(modal => ({ ...modal, Index: index, Action: "Edit", Item: inLueItem.Item, Quantity: inLueItem.Quantity }))
    }

    //Handle delete
    const HandleDeleteInLue = (bodyIndex, index) => {
        let MainItemRowNumber = ItemRowNo;
        if (bodyIndex !== 0)
            MainItemRowNumber = bodyIndex;
        setSaveData(prevSaveData => {
            const newData = { ...prevSaveData };
            newData.ItemDetails[MainItemRowNumber].InLueItem.splice(index, 1)
            return newData;
        });
        HandleResetInLue()
    }

    useEffect(() => {
        handleInvoiceData()
        setFocus('txtCustomer');
        setTitle('GenerateInvoice', setOpen);
        setSalesPersonPre(SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>

                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoiceFromDate") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={SaveData.Customer ? SaveData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)
                                                    handleGetOrderData(newInputValue);
                                                    handleGetEmptiesData(newInputValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Invoice No<span className="Required">*</span></label>
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value='System-Generated'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <DateBox
                                                id='txtInvoiceFromDate'
                                                inputrefs={inputrefs}
                                                disabled={true}
                                                label='Invoice Date'
                                                placeholder="Invoice Date"
                                                required={false}
                                                selected={SaveData.InvoiceDate === '' ? '' : new Date(SaveData.InvoiceDate)}
                                                onChange={(e) => {
                                                    let dateArr = e?.toString()?.split(' ')
                                                    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
                                                    setSaveData({ ...SaveData, InvoiceDate: dateArr })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItemNo") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson ? SaveData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    setSalesPersonPre(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/*Item section Start*/}
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-1">

                                        <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                            <div className="table-responsive">
                                                <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                    <thead className="sticky-top">
                                                        <tr>
                                                            <th>Item No<span className="Required">*</span></th>
                                                            <th style={{ textAlign: 'right' }}>Item Price</th>
                                                            <th style={{ textAlign: 'right' }}>Quantity In Hand</th>
                                                            <th style={{ textAlign: 'right' }}>Quantity<span className="Required">*</span></th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr>
                                                            <td className='col-lg-6 col-md-6 col-sm-12 col-12'>
                                                                <div className="fields">
                                                                    <AutoCompleteBox
                                                                        inputrefs={inputrefs}
                                                                        style={{ minWidth: '200px' }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') { setFocus("txtQuantity") };
                                                                        }}
                                                                        label=''
                                                                        placeholder="Item No"
                                                                        maxLength='50'
                                                                        options={ItemNoArr}
                                                                        id='txtItemNo'
                                                                        required={true}
                                                                        ignore_common={true}
                                                                        onFocus={() => getItemNo()}
                                                                        onBlur={(e) => handleGetItemDetails(e.target.value)}
                                                                        inputValue={AddExtraItem.Item ? AddExtraItem.Item : ''}
                                                                        onInputChange={(event, newInputValue) => {
                                                                            SetAddExtraItem({ ...AddExtraItem, Item: newInputValue });
                                                                        }}

                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className='fields' style={{ textAlign: 'right' }}>
                                                                <b>{AddExtraItem.ItemPrice}</b>
                                                            </td>
                                                           
                                                            <td className='fields' style={{ textAlign: 'right' }}>
                                                                {AddExtraItem.InHandQuantity}
                                                            </td>
                                                            <td className='fields'>
                                                                <input className="form-control" type='text'
                                                                    id={`txtQuantity`}
                                                                    style={{ minWidth: '70px', textAlign: 'right' }}
                                                                    maxLength="10"
                                                                    value={AddExtraItem.RequiredQuantity}
                                                                    onChange={(e) => { handleOnChangeItemQuantity(e) }}
                                                                    onFocus={(e) => { e.target.select(); }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            setFocus('btnAddExtraItem');
                                                                        };
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className='fields'>
                                                                <button
                                                                    title="Add Item"
                                                                    className="btn btn-link text-success btn-sm"
                                                                    id='btnAddExtraItem'
                                                                    onClick={handleAddNewItem}
                                                                >
                                                                    <i className="bi bi-plus"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        SaveData ? (
                                            <div className="col-lg-12 col-md-12 col-sm-12 mt-1">
                                                <div className="heading-box">
                                                    <div className="heading d-flex gap-4">
                                                        <h6 className="m-0 font-weight-bold text-primary" >Customer Item Details</h6>
                                                    </div>
                                                </div>
                                                <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                    <div className="table-responsive">
                                                        <table className="table-bordered" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    <th>Del</th>
                                                                    <th>Item</th>
                                                                    <th style={{ textAlign: 'right' }}>Quantity</th>
                                                                    <th style={{ textAlign: 'right' }}>Return Quantity</th>
                                                                    <th style={{ textAlign: 'right' }}>Item Price</th>
                                                                    <th style={{ textAlign: 'right' }}>Quantity Inhand</th>
                                                                    <th style={{ textAlign: 'right' }}>Net Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SaveData.ItemDetails?.map((item, bodyIndex) => (
                                                                    <tr className="TableTrhover" key={`row${bodyIndex}`}  >
                                                                        <td>
                                                                            {item.IsMainItem ?
                                                                                <button title="Delete Item" className="btn btn-link text-danger btn-sm" onClick={() => { handleRemoveExtraItemRow(item.Item) }}>
                                                                                    <i className="bi bi-trash"></i>
                                                                                </button>
                                                                                :
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        id='chkItemEnable'
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        checked={item.IsItemEnable}
                                                                                        onChange={(e) => {
                                                                                            const newItemDetails = [...SaveData.ItemDetails];
                                                                                            newItemDetails[bodyIndex].IsItemEnable = e.target.checked;
                                                                                            newItemDetails[bodyIndex].RequiredQuantity = 0;
                                                                                            newItemDetails[bodyIndex].ReturnQuantity = newItemDetails[bodyIndex].InHandQuantity;
                                                                                            newItemDetails[bodyIndex].NetAmount = 0;
                                                                                            setSaveData({
                                                                                                ...SaveData,
                                                                                                ItemDetails: newItemDetails
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </td>


                                                                        <td style={{ width: '40%' }}>
                                                                            {item.IsMainItem ?

                                                                                <span>
                                                                                    <b>{item.Item}</b>
                                                                                </span>
                                                                                :
                                                                                <div style={{ paddingLeft: '20px' }}>
                                                                                    {/*<span style={{ fontSize: "13px" }}>{item.Item}*/}
                                                                                    {/*<button displa*/}
                                                                                    {/*    title="Add Item"*/}
                                                                                    {/*    className="btn btn-link text-success btn-sm"*/}
                                                                                    {/*    style={{ marginBottom: '0px', marginLeft: "30px" }}*/}
                                                                                    {/*    data-bs-toggle="modal" data-bs-target="#addModal"*/}
                                                                                    {/*    onClick={() => {*/}
                                                                                    {/*        //ModalClear();*/}
                                                                                    {/*        let a = document.querySelectorAll('.sc-eqUAAy');*/}
                                                                                    {/*        if (a.length > 0) {*/}
                                                                                    {/*            a[0].children[0].children[0].innerHTML = '';*/}
                                                                                    {/*        }*/}
                                                                                    {/*        setItemGroup(item.ItemGroup);*/}
                                                                                    {/*        setItemRowNo(bodyIndex);*/}
                                                                                    {/*        setMainItemName("In lieu of Item " + item.Item.split(':')[0] + " of " + item.InHandQuantity +" Quantity");*/}
                                                                                    {/*    }}*/}
                                                                                    {/*>*/}
                                                                                    {/*    <i className="bi bi-plus"></i>*/}
                                                                                    {/*</button>*/}
                                                                                    {/*</span>*/}
                                                                                    <select
                                                                                        key={bodyIndex}
                                                                                        // value={ SaveData.EmptiesDetails[bodyIndex]?.InLueItem?.[0] || "" }




                                                                                        onChange={(e) => handleEmptyItemDropdownChange(e, bodyIndex, item)}
                                                                                    >
                                                                                        {/*<option value={item.Item ? item.Item.split(" : ")[0] : ""} key={bodyIndex}> {item.Item} </option>*/}
                                                                                        {/*{emptyItemDropdown.ItemDetails*/}
                                                                                        {/*.filter((option) => item.Item !== option.ItemNo) // Exclude matching item*/}
                                                                                        {/*.map((option, optionIndex) => (*/}
                                                                                        {/*    <option key={optionIndex} value={option.EmptyItemCode}>*/}
                                                                                        {/*        {option.ItemNo}*/}
                                                                                        {/*    </option>*/}
                                                                                        {/*))}*/}
                                                                                        {ItemDetailsDropDown[bodyIndex]?.map((option, optionIndex) => (

                                                                                            <option key={optionIndex} value={option.EmptyItemCode}>
                                                                                                {option.ItemNo}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                    
                                                                                </div>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control" type='text'
                                                                                id={`txtIssuedQuantity${bodyIndex + 1}`}
                                                                                style={{ textAlign: 'right' }}
                                                                                value={item.RequiredQuantity}
                                                                                disabled={item.IsOrderItem === false && item.IsMainItem ? "disabled" : item.IsItemEnable ? "" : "disabled"}
                                                                                onFocus={(e) => { e.target.select(); }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        let element = document.getElementById(`txtRQuantity${bodyIndex + 1}`)
                                                                                        if (element) {
                                                                                            element.select();
                                                                                        }
                                                                                        else {
                                                                                            setFocus('btnSave');
                                                                                        }
                                                                                    };
                                                                                }}
                                                                                maxLength="10"
                                                                                onChange={(e) => { handleOnChangeCustomerQuantity(e, bodyIndex) }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {item.IsMainItem ? "" :
                                                                                <input className="form-control" type='text'
                                                                                    id={`txtRQuantity${bodyIndex + 1}`}
                                                                                    style={{ textAlign: 'right' }}
                                                                                    value={item.ReturnQuantity}
                                                                                    disabled={item.IsItemEnable ? "" : "disabled"}
                                                                                    onFocus={(e) => { e.target.select(); }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            let element = document.getElementById(`txtRQuantity${bodyIndex + 2}`)
                                                                                            if (element) {
                                                                                                element.select();
                                                                                            }
                                                                                            else {
                                                                                                setFocus('btnSave');
                                                                                            }
                                                                                        };
                                                                                    }}
                                                                                    maxLength="10"
                                                                                    onChange={(e) => { handleOnChangeCustomerReturnQuantity(e, bodyIndex) }}
                                                                                />}
                                                                        </td>
                                                                        <td style={{ textAlign: 'right' }}>
                                                                            <b>{item.ItemPrice}</b>

                                                                        </td>

                                                                       
                                                                        <td style={{ textAlign: 'right' }}>{item.InHandQuantity}</td>
                                                                        {/*<td style={{ textAlign: 'right' }}>{(+item.NetAmount).toFixed(2)}</td>*/}
                                                                        <td style={{ textAlign: 'right' }}><b>{(+item.NetAmount)}</b></td>
                                                                    </tr>
                                                                ))}
                                                                <tr>
                                                                    <td colSpan='6' style={{ textAlign: 'right' }} ><b>Total</b></td>
                                                                    {/* <td style={{ textAlign: 'right' }}><b>{InvoiceData.TotalNetAmount.toFixed(2)}</b></td>*/}
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.GrandTotalAmount}</b></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (<> </>)
                                    }
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-1">
                                        <div className="row">
                                            {
                                                SaveData.EmptiesDetails.length > 0 ? (
                                                    <div className="col-lg-8 col-md-8 col-sm-12">
                                                        <div className="heading-box">
                                                            <div className="heading d-flex gap-4">
                                                                <h6 className="m-0 font-weight-bold text-primary" >Empties Item Details</h6>
                                                            </div>
                                                        </div>

                                                        <div className="op-invoice recoard-bata service-content-area">
                                                            <div className="table-responsive">
                                                                <table className="table-bordered" width="100%" cellSpacing="0">
                                                                    <thead className="sticky-top">
                                                                        <tr>
                                                                            <th>Item No</th>
                                                                            <th style={{ textAlign: 'right' }}>Item Price</th>
                                                                            <th style={{ textAlign: 'right' }}>Quantity</th>
                                                                            <th style={{ textAlign: 'right' }}>Return Quantity<span className="Required">*</span></th>
                                                                            <th style={{ textAlign: 'right' }}>Invoice Quantity<span className="Required">*</span></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {SaveData.EmptiesDetails?.map((item, bodyIndex) => (

                                                                            <tr key={bodyIndex}>

                                                                                <td className='fields'>
                                                                                    {item.Item}
                                                                                </td>
                                                                                <td style={{ textAlign: 'right' }} className='fields'>
                                                                                    <b>{parseFloat(Number(item.ItemPrice).toFixed(1))}</b>
                                                                                    {/*<td style={{ textAlign: 'right' }}><b>{(item.ItemPrice)}</b></td>*/}
                                                                                </td>
                                                                                <td className='fields' style={{ textAlign: 'right' }}>
                                                                                    {item.Quantity}
                                                                                </td>
                                                                                <td className='fields'>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        type='text'
                                                                                        id={`txtReturnQuantity${bodyIndex + 1}`}
                                                                                        maxLength="10"
                                                                                        value={item.ReturnQuantity}
                                                                                        onChange={(e) => { handleOnChangeEmptiesReturnQuantity(e, bodyIndex) }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </td>
                                                                                <td className='fields'>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        type='text'
                                                                                        id={`txtEnvoiceEmpties${bodyIndex + 1}`}
                                                                                        maxLength="10"
                                                                                        value={item.InvoiceQuantity}
                                                                                        onChange={(e) => { handleOnChangeEmptiesInvoiceQuantity(e, bodyIndex) }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                    <tfoot>
                                                                        <tr>
                                                                            <td colSpan="4" style={{ textAlign: 'right' }}><b>Total</b></td>
                                                                            <td style={{ textAlign: 'right' }}><b>{TotalEmptyInvoiceAmount.toFixed(2)}</b></td>
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (<div className="col-lg-8 col-md-8 col-sm-12"></div>)
                                            }
                                            <div className="col-lg-4 col-md-4 col-sm-12" style={{ float: 'right' }}>
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    {/*<div className="op-invoice recoard-bata service-content-area">*/}
                                                    {/*    <div className="table-responsive">*/}
                                                    {/*        <table className="table-bordered" width="100%" cellSpacing="0">*/}
                                                    {/*            <thead className="sticky-top">*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <th colSpan='2'>Invoice Detail</th>*/}
                                                    {/*                </tr>*/}
                                                    {/*            </thead>*/}
                                                    {/*            <tbody>*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>GETFUND ({InvoiceData.GETFUNDPer.toFixed(2)} %)</b></td>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.GetFundAmount}</b></td>*/}
                                                    {/*                </tr>*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>NHIL ({InvoiceData.NHILPer.toFixed(2)} %)</b></td>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.NhilAmount}</b></td>*/}
                                                    {/*                </tr>*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>COVID LEVY ({InvoiceData.COVIDPer.toFixed(2)} %)</b></td>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.CovidAmount}</b></td>*/}
                                                    {/*                </tr>*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>VAT ({InvoiceData.VATPer.toFixed(2)} %)</b></td>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.VatAmount}</b></td>*/}
                                                    {/*                </tr>*/}
                                                    {/*                <tr>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>Grand Total Amount</b></td>*/}
                                                    {/*                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.GrandTotalAmount}</b></td>*/}
                                                    {/*                </tr>*/}
                                                    {/*            </tbody>*/}
                                                    {/*        </table>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    {PaymentType === "-1" ?
                                                        <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginTop: "3px", border: "1px solid black", borderRadius: "5px" }}>
                                                            <div className="heading-box" style={{ backgroundColor: "green" }}>
                                                                <div className="heading d-flex gap-4">
                                                                    <h6 className="m-0 font-weight-bold text-primary" >Payment Collection</h6>
                                                                </div>
                                                            </div>
                                                            <div className="form-box service-content-area" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                                                <div className="row align-items-end">
                                                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                                                        <div className="fields">
                                                                            <label className="form-label">Cash Amount</label>
                                                                            <input
                                                                                id='txtCashAmount'
                                                                                type="text"
                                                                                style={{ textAlign: 'right' }}
                                                                                maxLength="10"
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        setFocus('txtMobileMoney')
                                                                                    };
                                                                                }}
                                                                                className="form-control"
                                                                                placeholder="Cash Amount"
                                                                                value={SaveData.CashAmount}
                                                                                onChange={(e) => {
                                                                                    let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                    let TotalReceipt = parseFloat(SaveData.MobileMoney) + parseFloat(SaveData.ChequeAmount) + parseFloat(inputValue);
                                                                                    if (TotalReceipt > InvoiceData.TotalNetAmount) {
                                                                                        AlertBox("error", "Received amount should not more than Total.", "txtCashAmount");
                                                                                        inputValue = 0.00;
                                                                                    }
                                                                                    HandleChange("CashAmount", inputValue);

                                                                                }}
                                                                                onFocus={(e) => { e.target.select(); }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                                                        <div className="fields">
                                                                            <label className="form-label">Mobile Money</label>
                                                                            <input
                                                                                id='txtMobileMoney'
                                                                                type="text"
                                                                                style={{ textAlign: 'right' }}
                                                                                maxLength="10"
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        setFocus('txtChequeAmount')
                                                                                    };
                                                                                }}
                                                                                className="form-control"
                                                                                placeholder="Mobile Money"
                                                                                value={SaveData.MobileMoney}
                                                                                onChange={(e) => {
                                                                                    let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                    let TotalReceipt = parseFloat(SaveData.CashAmount) + parseFloat(SaveData.ChequeAmount) + parseFloat(inputValue);
                                                                                    if (TotalReceipt > InvoiceData.GrandTotalAmount) {
                                                                                        AlertBox("error", "Received amount should not more than Grand Total.", "txtMobileMoney");
                                                                                        inputValue = 0.00;
                                                                                    }
                                                                                    HandleChange("MobileMoney", inputValue);
                                                                                }}
                                                                                onFocus={(e) => { e.target.select(); }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                                                        <div className="fields">
                                                                            <label className="form-label">Cheque Amount</label>
                                                                            <input
                                                                                id='txtChequeAmount'
                                                                                type="text"
                                                                                style={{ textAlign: 'right' }}
                                                                                maxLength="10"
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        setFocus('txtChequeNo')
                                                                                    };
                                                                                }}
                                                                                className="form-control"
                                                                                placeholder="Cheque Amount"
                                                                                value={SaveData.ChequeAmount}
                                                                                onChange={(e) => {
                                                                                    let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                    let TotalReceipt = parseFloat(SaveData.CashAmount) + parseFloat(SaveData.MobileMoney) + parseFloat(inputValue);
                                                                                    if (TotalReceipt > InvoiceData.GrandTotalAmount) {
                                                                                        AlertBox("error", "Received amount should not more than Grand Total.", "txtChequeAmount");
                                                                                        inputValue = 0.00;
                                                                                    }
                                                                                    HandleChange("ChequeAmount", inputValue, SaveData.ChequeDate = '', SaveData.ChequeNo = '');

                                                                                }}
                                                                                onFocus={(e) => { e.target.select(); }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    {parseFloat(SaveData.ChequeAmount) > 0 ?
                                                                        <>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                <div className="fields">
                                                                                    <label className="form-label">Cheque No</label>
                                                                                    <input
                                                                                        id='txtChequeNo'
                                                                                        type="text"
                                                                                        maxLength="20"
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                setFocus('txtChequeDate')
                                                                                            };
                                                                                        }}
                                                                                        className="form-control"
                                                                                        placeholder="Cheque No"
                                                                                        value={SaveData.ChequeNo}
                                                                                        onChange={(e) => {
                                                                                            HandleChange("ChequeNo", e.target.value);
                                                                                        }}
                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6">
                                                                                <div className="fields">
                                                                                    <label className="form-label">Cheque Date</label>
                                                                                    <DatePicker
                                                                                        selected={ReverseFormatDate(SaveData.ChequeDate)}
                                                                                        id='txtChequeDate'
                                                                                        className="form-control"
                                                                                        placeholderText="Cheque Date"
                                                                                        dateFormat={'dd-MMM-yyyy'}
                                                                                        autoComplete='off'
                                                                                        onChange={(date) => {
                                                                                            setSaveData({ ...SaveData, ChequeDate: formatDate(date) })
                                                                                        }}
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                setFocus('txtChequeDate')
                                                                                            };
                                                                                        }}
                                                                                        minDate={new Date()}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </> : <></>}
                                                                </div>
                                                            </div>
                                                        </div> : <></>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/* Item section End*/}
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSave' onClick={handleSaveData}>
                                                <i className="bi bi-check" />Generate Invoice
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            {/*{(Print?.IsInvoicePrint && Print?.InvoiceNo) ?*/}
                                            {/*    <>*/}
                                            {/*        <button className="button save-btn" onClick>*/}
                                            {/*            <i className="bi bi-printer" /> Invoice Print*/}
                                            {/*        </button>*/}
                                            {/*    </>*/}
                                            {/*    :*/}
                                            {/*    <></>*/}
                                            {/* }*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="addModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="aboutUsLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content" style={{ background: "#F0F6FF", height: "400px" }}>
                            <div className="modal-header" style={{ padding: '7px 15px', backgroundColor: "black", color: "white" }}>
                                <h5 className="modal-title" id="addModalLabel">{MainItemName}</h5>
                                <button type="button" className="btn btn-light" data-bs-dismiss="modal" style={{ margin: '-1px', minWidth: '30px' }} onClick={HandleResetInLue}> <i className="fa-solid fa-xmark" /></button>
                            </div>
                            <div className="modal-body table-responsive">
                                <div className="container-fluid">
                                    <div className='col-12'>
                                        <div className='row'>
                                            <div className='col-lg-5'>
                                                <div className="form-group text-start mb-3" >
                                                    <div className="fields">
                                                        <AutoCompleteBox
                                                            inputrefs={inputrefs}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') { setFocus("txtInLueQuantity") };
                                                            }}
                                                            label='Item'
                                                            placeholder="Empty Item"
                                                            maxLength='50'
                                                            options={ItemNoArr}
                                                            PopperComponent={(props) => (
                                                                <div {...props} style={{ zIndex: 1501, position: 'absolute', width: '36%' }} />
                                                            )}
                                                            id='txtInLueEmptyItemNo'
                                                            required={true}
                                                            ignore_common={true}
                                                            onFocus={() => getEmptyItemNo()}
                                                            inputValue={modal.Item ? modal.Item : ''}
                                                            onInputChange={(event, newInputValue) => {
                                                                setModal({ ...modal, Item: newInputValue });
                                                            }}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-3'>
                                                <div className="form-group text-start mb-3" >
                                                    <div className="fields">
                                                        <label className="form-label ">Quantity <span className="Required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            ref={ref => (inputrefs.current['Quantity'] = ref)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') { setFocus("btnAddInLue") };
                                                            }}
                                                            style={{ textAlign: 'right' }}
                                                            id='txtInLueQuantity'
                                                            value={modal.Quantity}
                                                            onChange={(e) => setModal({ ...modal, Quantity: e.target.value.replace(/\D/g, "") })}
                                                            onFocus={(e) => { e.target.select(); }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-2  mt-3'>
                                                <button type="button" id="btnAddInLue" class="btn btn-success" onClick={() => HandleAddInLue()} style={{ margin: '5px', minWidth: '30px' }}>Add <i className="bi bi-plus"></i></button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        {SaveData && SaveData.ItemDetails.length > ItemRowNo && SaveData.ItemDetails[ItemRowNo].InLueItem.length > 0 &&

                                            <div className='mt-1 p-2'>
                                                <div className='row'>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top" style={{ backgroundColor: "#555555", color: "white" }}>
                                                                <tr className='light-bg'>
                                                                    <th style={{ width: '5px' }}>Action</th>
                                                                    <th style={{ width: '20px' }}>Item</th>
                                                                    <th style={{ width: '10px' }}>Quantity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SaveData.ItemDetails[ItemRowNo].InLueItem.map((item, index) => {
                                                                    return <tr key={index}>
                                                                        <td style={{ width: '10%' }}>
                                                                            <i className="fa-regular fa-pen-to-square text-success me-2" onClick={() => handleEditInLue(index)} />
                                                                            <i className="fa-regular fa-trash-can text-danger me-2" onClick={() => HandleDeleteInLue(0, index)} />
                                                                        </td>
                                                                        <td style={{ width: '40%' }}>{item.Item}</td>
                                                                        <td style={{ textAlign: 'right', width: '10%' }}>{item.Quantity}</td>
                                                                    </tr>
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>}


                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer" style={{ padding: '3px' }}>
                                <button type="button" className="btn btn-success" data-bs-dismiss="modal" style={{ margin: '5px', minWidth: '30px' }}
                                >Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default GenerateInvoice_New